/* eslint-disable react/jsx-filename-extension */
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { AuthProvider } from 'react-oidc-context';
import { oidcConfig } from 'keycloak/authConfig';
import { getAppConfigVar } from 'shared/helpers';
import * as Sentry from '@sentry/react';
import { GlobalError } from 'shared/components';
import store from 'redux/store';
import App from './App';
// import * as serviceWorker from './serviceWorker';
import './index.scss';

import './i18n';

const sentryDSN = getAppConfigVar('sentryDSN', '');

if (sentryDSN) {
  Sentry.init({ dsn: sentryDSN });
}

ReactDOM.render(
  <Sentry.ErrorBoundary fallback={GlobalError}>
    <AuthProvider {...oidcConfig}>
      <Provider store={store}>
        <Suspense fallback="...">
          <App />
        </Suspense>
      </Provider>
    </AuthProvider>
  </Sentry.ErrorBoundary>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
